var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.49 56.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M16.8 16.86a7.7 7.7 0 0 0 2.08.67 7.3 7.3 0 0 0 1.4.12h0A8.16 8.16 0 0 0 28 12a7.8 7.8 0 0 0 .34-2.4 8.06 8.06 0 0 0-16.12 0 9 9 0 0 0 .33 2.4 8.1 8.1 0 0 0 4.25 4.86M39 55.29V34.38a10.5 10.5 0 0 0-10.37-10.44H11.76A10.26 10.26 0 0 0 1.8 32c-.19.78-.3 23.16-.3 23.16z",
    "data-name": "Layer 28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.120367dd288844656b1e536b03397647.svg";
export { ForwardRef as ReactComponent };